// @flow
/* eslint-disable flowtype/no-weak-types */
import { get, isEmpty } from 'lodash';
import moment from 'moment';

import { DEFAULT_KID_VALUE } from 'Store/trip-information/kids/constants';

function getAdultsWithoutMainContact(adults: ?Array<any>): Array<any> {
  return (adults || []).slice(1);
}

function getKidsBirthdate(kids: ?Array<any>): Array<moment> {
  return (kids || [])
    .map(kid => get(kid, 'birthdate'))
    .filter(Boolean) // kids may not have a birthdate
    .map(birthdate => moment(birthdate));
}

function getFormattedKidsBirthdate(kids: ?Array<any>, dateFormat: string): Array<string> {
  return getKidsBirthdate(kids).map(birthdate => moment(birthdate).format(dateFormat));
}

function getResortInitialKids(
  kids: Array<*> = [],
  initialKidsNumber: number,
  isAdultOnlyResort: boolean,
): Array<*> {
  if (isAdultOnlyResort) {
    return [];
  }

  return isEmpty(kids) && initialKidsNumber > -1
    ? Array(initialKidsNumber).fill({ ...DEFAULT_KID_VALUE })
    : kids;
}

export {
  getAdultsWithoutMainContact,
  getKidsBirthdate,
  getFormattedKidsBirthdate,
  getResortInitialKids,
};
